import { getDepartments } from '@/api/department';

type IDepartmentInfo = IDepartment.IResponse.IDepartmentInfo;

export let companyAllDepartments: IDepartmentInfo[] = [];

export const getCompanyAllDepartments = () => {
  return new Promise((resolve, reject) => {
    getDepartments().then((res) => {
      companyAllDepartments = res.data;
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
